export const LOGINNAME_CHANGED = "LOGINNAME_CHANGED"
export const PASSWORD_CHANGED = "PASSWORD_CHANGED"

export const LOGINFAILDIALOG_SHOWN = "LOGINFAILDIALOG_SHOWN";
export const LOADINGOVERLAY_SHOWN = "LOADING_OVERLAY_SHOWN";
